<script>
  import { navigate } from "svelte-routing"
  export let empresas

  const cargarEmpresa = (ruc) => {
    // setTimeout(function () {
    //   navigate(`/empresa/${ruc}`, { replace: true })
    // }, 2000)
    navigate(`/empresa/${ruc}`, { replace: true })
  }
</script>

<div class="table-responsive small">
  <table class="table table-striped table-sm table-hover table-pointer">
    <thead>
      <tr>
        <th class="fg-secondary fw-normal">RUC</th>
        <th class="fg-secondary fw-normal">Razón Social</th>
        <th class="fg-secondary fw-normal" />
      </tr>
    </thead>
    <tbody>
      <tr on:click={() => cargarEmpresa(empresas.ruc)}>
        <td>{empresas.ruc}</td>
        <td>{empresas.razonsocial}</td>
        <td class="text-end fg-primary">
          <i class="bi bi-chevron-right"></i>
        </td>
      </tr>
    </tbody>
  </table>
</div>
